import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { snakes } from '@utils/lodash';
import { API_V1_BASE } from '@config';
import { UserProfile } from '@models/UserProfile';
import { WithParams } from '@utils/typescript';

export type UpdateUserProfileAuthParams = WithParams<{
  name: string;
  name_km: string;
  gender: string;
  dob: string;
  personal_code: string;
  occupation: string;
  email: string;
  address: string;
  height: number;
  weight: number;
  bmi: number;
}>;

export class AuthApi {
  static getUserProfile = async () => {
    return await authAxios
      .get(`${API_V1_BASE}/user/profile`)
      .then((response) => humps(response.data) as UserProfile);
  };

  static updateUserProfile = async (params: UpdateUserProfileAuthParams) => {
    return await authAxios
      .put(`${API_V1_BASE}/user/profile`, snakes(params))
      .then((response) => humps(response.data) as UserProfile);
  };
}
